import React from 'react';
import { Container } from 'react-bootstrap';
import { projects } from '../data/content';

const Portfolio = () => {
  return (
    <section id="portfolio" className="section">
      <Container>
        <div className="section-title">
          <h2>How We Do</h2>
        </div>
        <div className="portfolio-grid stagger-children">
          {projects.map(project => (
            <div className="portfolio-item" key={project.id}>
              {project.image ? (
                <picture>
                  <source media="(min-width: 992px)" srcSet={`${project.image}`} />
                  <img
                    src={project.image}
                    alt={`${project.title} screenshot`}
                    loading="lazy"
                    width="1200"
                    height="800"
                    style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                  />
                </picture>
              ) : (
                <div 
                  className="placeholder"
                  style={{ 
                    width: '100%', 
                    height: '250px', 
                    backgroundColor: project.bgColor,
                    position: 'relative'
                  }}
                >
                  <div className="chrome">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              )}
              <div className="overlay">
                <span className="chip">{project.category}</span>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <a href={project.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-light mt-2" aria-label={`Open ${project.title} project in new tab`}>
                  View Project
                </a>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Portfolio;
